import React, { useState } from "react";
import "./Modal.scss";
import Inputfield from "../Textfield/Textfield";
import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import { API, graphqlOperation } from "aws-amplify";
import {
	createProductCategory,
	updateProductCategory,
} from "../../graphql/mutations";
import Snackbar from "../Snackbar/Snackbar";

const ProductCategory = ({ setopenmodal, item, editCat }) => {
	const { t } = useTranslation();
	const [category, setCategory] = useState(item ? item : "");
	const [processing, setProcessing] = useState(false);
	const [msg, setMsg] = useState("");
	const [errMsg, setErrMsg] = useState("");

	const add = () => {
		setProcessing(true);
		API.post("laetusapi", "/api/v1/addcategory", {
			body: {
				categoryName: category,
			},
		})
			.then((res) => {
				API.graphql(
					graphqlOperation(createProductCategory, {
						input: {
							categoryName: category,
							webflowId: res._id,
						},
					}),
				)
					.then((res) => {
						setProcessing(false);
						setMsg(t("category-add"));
						setTimeout(() => {
							setopenmodal(false);
							setMsg("");
						}, 1500);
					})
					.catch((err) => {
						setProcessing(false);
						setErrMsg(err.message);
						setopenmodal(false);
						setTimeout(() => {
							setErrMsg("");
						}, 1500);
					});
			})
			.catch((err) => {
				setProcessing(false);
			});
	};

	const edit = () => {
		setProcessing(true);
		API.patch("laetusapi", "/api/v1/updatecategory", {
			body: {
				categoryName: category,
				id: editCat.webflowId,
				slug: category.toLowerCase().replace(/ /g, "-"),
			},
		})
			.then((res) => {
				API.graphql(
					graphqlOperation(updateProductCategory, {
						input: {
							id: editCat.id,
							categoryName: category,
						},
					}),
				)
					.then((res) => {
						setProcessing(false);
						setMsg(t("category-edit"));
						setTimeout(() => {
							setopenmodal(false);
							setMsg("");
						}, 1500);
					})
					.catch((err) => {
						setProcessing(false);
						setErrMsg(err.message);
						setTimeout(() => {
							setopenmodal(false);
							setErrMsg("");
						}, 1500);
					});
			})
			.catch((err) => {
				setProcessing(false);
			});
	};

	return (
		<div style={{ marginTop: "5px" }}>
			<Inputfield
				type="text"
				value={category}
				onChange={(e) => setCategory(e.target.value)}
				placeholder={t("cat-name")}
			/>
			<div className="addButton">
				<Button
					text={t("add")}
					onClick={() => (item ? edit() : add())}
					loader={processing}
				/>
			</div>
			{msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
		</div>
	);
};

export default ProductCategory;
